import React from "react";
import { Link } from "react-router-dom";

const isExternalHref = (href = "") => /^(https?:\/\/|mailto:|tel:)/i.test(String(href || "").trim());
const normalizeOpenMode = (value = "") => {
  const normalized = String(value || "").trim();
  return ["auto", "same-tab", "new-tab"].includes(normalized) ? normalized : "auto";
};

export function PromotionLink({ href, isExternal, openMode, className, children, ...rest }) {
  if (!href) {
    return (
      <span className={className} {...rest}>
        {children}
      </span>
    );
  }

  const external = Boolean(isExternal) || isExternalHref(href);
  const resolvedOpenMode =
    normalizeOpenMode(openMode) === "auto"
      ? external
        ? "new-tab"
        : "same-tab"
      : normalizeOpenMode(openMode);

  if (resolvedOpenMode === "new-tab") {
    return (
      <a href={href} className={className} target="_blank" rel="noreferrer" {...rest}>
        {children}
      </a>
    );
  }

  if (external) {
    return (
      <a href={href} className={className} {...rest}>
        {children}
      </a>
    );
  }

  return (
    <Link to={href} className={className} {...rest}>
      {children}
    </Link>
  );
}

export default PromotionLink;
